export default {
	name: 'Username',
	nameError: 'Username is required.',
	email: 'Email Address',
	emailRequiredError: 'Email Address is required.',
	emailInvalidError: 'Invalid email address.',
	phone: 'Phone number (optional)',
	phoneError: 'Invalid Phone.',
	title: 'Please notify me when the box size I require becomes available.',
	boxButton: 'Request box',
	sendButton: 'Send',
	privacyPolicy: 'I have read and accepted the privacy policy.',
	privacyPolicyError: 'Please accept our privacy policy.',
};